import React from 'react'
import Container from '../../../CandidateExperience/components/Container'
import styles from './styles'

const HorizontalContainer = ({ children }) => <Container className={styles.wrapper}>{children}</Container>

export default HorizontalContainer
